<template>
  <div class="modal-drill-library">

    <a-table rowKey="id" class="management-table" :dataSource="dataSource" :loading="industryPagesLoading"
      :columns="columns" @change="changePage" :scroll="{ y: '90%' }" :pagination="paginationOption">
      <template #serial="{ index }">{{ index + 1 }}</template>
      <template #intervalGrade="{ record }">{{ record.unitSavour ? (record.intervalGrade + `
        `+ record.unitSavour) : record.intervalGrade }}</template>

    </a-table>


  </div>
</template>

<script setup>
import { ref, reactive, watch } from 'vue';

import { getPageApi, } from '@/api/drillLibrary/utilsApi';

import config from '@/config/config';
import tableConfig from '@/components/DrillLibrary/management/tableConfig';

const columns = tableConfig.splice(0, tableConfig.length - 1);

const props = defineProps({
  modalDrillParams: {
    type: Object,
    default: () => ({}),
  },
})


const requestParams = {
  timer: null,
  // 项目名称：
  propName: null,
  // 项目持有方：
  owner: null,
  // 项目所在区域
  globalRegion: null,
  // 项目所在国家
  countryName: null,
  // 项目大发展阶段：
  stage: null,
  // 钻孔区间z主矿种：
  intervalCommoditiesArr: [],
  // 是否仅筛选主矿种：
  sift: 1,
  // 钻孔区间长：
  minIntervalLength: null,
  // 钻孔区间长：
  maxIntervalLength: null,
  // 钻孔报告时间：
  reportDate: null,
  // 钻孔报告时间：
  startReportDate: null,
  // 钻孔报告时间：
  endReportDate: null,
  // 钻孔报告公司：
  reportingCompany: null,
  // 钻孔目的：
  explorationPurpose: null,
  // 页数
  page: 1,
  size: 6,
  // 升序降序
  order: 'asc',
}


const industryPagesLoading = ref(false)
let dataSource = ref([]);


const selectedKeys = ref([]); // 表格选中id
const selectAll = ref('n  ');
const paginationOption = ref({
  total: 0,
  pageSize: 6,
  current: 1,
  showSizeChanger: true,
  showQuickJumper: true,
  pageSizeOptions: ['6', '10', '20', '30', '40', '50',],
});

// 确认弹窗 公用
const confirmModalConf = reactive({
  loading: false,
  visible: false,
  title: '',
  confirm: null,
  remark: '',
  callback: null,
  showRemark: true,
  showUpload: false,
  showDown: false,
  selectValue: [],
  fileList: [],
});


/**
 * @description 表格选中事件
 */
const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows, 'onChange');
    selectedKeys.value = selectedRowKeys;
  },
  onSelect: (record, selected, selectedRows) => {
    selectAll.value = 'n';
    console.log(record, selected, selectedRows, 'onSelect');
  },
  onSelectAll: (selected, selectedRows, changeRows) => {
    selectAll.value = 'y';
    console.log(selected, selectedRows, changeRows, 'onSelectAll');
  },
};



/**
 * @description 查询
 */
const searchHandle = () => {

  requestParams.propName = props.modalDrillParams.propName;
  requestParams.propId = props.modalDrillParams.propId;
  requestParams.globalRegion = props.modalDrillParams.globalRegion;
  requestParams.countryName = props.modalDrillParams.countryName;

  industryPagesLoading.value = true
  getPageApi(requestParams)
    .then((res) => {
      industryPagesLoading.value = false
      dataSource.value = res.data.list || [];
      paginationOption.value.total = res.data.totalCount;
      paginationOption.value.current = res.data.currPage;
      paginationOption.value.pageSize = res.data.pageSize;

    })
    .catch(() => {
      confirmModalConf.visible = false;
    });
};

/**
 * @description 页码change事件
 */
const changePage = (page) => {
  requestParams.page = page.current;
  requestParams.size = page.pageSize;
  searchHandle();
};


watch(() => props.modalDrillParams, (val) => {
  if (val) {
    requestParams.page = 1;
    requestParams.size = 6;
    searchHandle();
  }
}, { immediate: true, deep: true })
</script>

<style lang="scss">
.modal-drill-library {
  height: 100%;
  background: rgba(179, 150, 92, 0.05);
  left: 0;
  z-index: 100;
  height: 100%;
  padding-right: 0.2rem;



  /* 表格样式 */
  .management-table {
    height: calc(100% - 0.5rem);

    .ant-spin-container {
      display: flex;
      flex-direction: column;
      align-items: end;
    }

    .ant-spin-nested-loading,
    .ant-spin-container,
    .ant-table-content {
      height: 100%;
    }

    .ant-table {
      height: calc(100% - .70rem);
      background: none;
      padding-left: 0.1rem;

      .ant-table-scroll {
        height: 100%;
        overflow: visible;
        overflow-x: visible;

        .ant-table-header {
          overflow: visible !important;
          margin-bottom: 0 !important;
        }
      }

      .ant-table-header {
        background: none;
      }

      .ant-table-body {
        overflow-x: hidden !important;
        overflow-y: auto !important;
        background: none;
      }

      /* 矿种 */
      .primary-commodity-img {
        width: 0.8rem;
        height: 0.6rem;
      }

      /* 图标 */
      .action-icons {
        display: flex;
        justify-content: center;

        i {
          font-size: 0.22rem;
          margin-right: 0.04rem;
          cursor: pointer;
        }

        .hide {
          opacity: 0.5;
          color: #666;
        }

        .crud-wrapper {
          display: flex;
          height: 0.25rem;
          padding: 0 0.1rem;
          margin-top: 0.05rem;

          .crud-item {
            margin-right: 0.04rem;
            width: 0.55rem;
            line-height: 0.25rem;
            font-size: 0.1rem;
            color: #fff;
            // background-color: #efb227;
            background-image: url(~@/static/images/dataManagement/curd_btn.png);
            background-size: 100% 100%;
            text-align: center;
          }

          .crud-item:hover {
            cursor: pointer;
          }

          .crud-item-disabled {
            pointer-events: none;
            color: rgba(255, 255, 255, 0.6);
            // background-color: rgba(239, 178, 39, 0.6);
            opacity: 0.8;
          }

          .crud-item-disabled:hover {
            cursor: no-drop;
          }
        }
      }

      .ant-table-thead {
        border: .01rem solid #4d3f1c;
        border-radius: .10rem .10rem 0rem 0rem;
        background: none;
      }

      .ant-table-thead>tr>th {
        color: #dccdab;
        background: rgba(179, 150, 92, 0.2);
        border: none;
      }

      .ant-table-tbody>tr>td {
        background-color: transparent;
        color: #fff;
        border-bottom: .01rem solid rgba(179, 150, 92, 1);
        vertical-align: middle;
      }

      .ant-table-placeholder {
        height: 100%;
        background-color: rgba(77, 63, 28, 1);
        border-top: rgba(179, 150, 92, 1);
        border-bottom: rgba(179, 150, 92, 1);
      }

      .ant-empty-normal {
        color: rgba(179, 150, 92, 1);
      }

      // 暂无数据填充样式
      // .ant-empty-img-simple-path {
      //   fill: rgba(77, 63, 28, 1);
      // }
      // .ant-empty-img-simple-ellipse {
      //   fill: rgba(77, 63, 28, 1);
      // }
      .ant-table-thead>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-tbody>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-thead>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
        background-color: rgba(179, 150, 92, 0.6);
      }

      .ant-table-thead>tr:hover.ant-table-row-selected>td,
      .ant-table-tbody>tr:hover.ant-table-row-selected>td {
        background-color: rgba(179, 150, 92, 0.6);
      }

      .ant-table-tbody>tr.ant-table-row-selected td {
        background-color: rgba(77, 63, 28, 1);
        color: #fff;
      }
    }
  }
}
</style>
